import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    IconButton
} from "@mui/material";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { DndContext, useDroppable } from "@dnd-kit/core";

function DropZone({ onFileSelect }) {
    const { isOver, setNodeRef } = useDroppable({
        id: "upload-dropzone"
    });

    const handleDrop = (event) => {
        event.preventDefault();
        const droppedFile = event.dataTransfer.files?.[0];
        if (droppedFile) onFileSelect(droppedFile);
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    return (
        <Box
            ref={setNodeRef}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            component="label"
            htmlFor="file-upload"
            sx={{
                border: "2px dashed",
                borderColor: isOver ? "primary.main" : "divider",
                borderRadius: 2,
                p: 4,
                textAlign: "center",
                cursor: "pointer",
                display: "block",
                transition: "all 0.2s",
                bgcolor: isOver ? "action.hover" : "transparent"
            }}
        >
            <CloudUploadOutlinedIcon
                color="primary"
                sx={{ fontSize: 40, mb: 1 }}
            />
            <Typography variant="body1" fontWeight={500}>
                {isOver ? "Drop file here" : "Click or drag file here"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
                Single file upload
            </Typography>

            <input
                id="file-upload"
                type="file"
                hidden
                onChange={(e) => onFileSelect(e.target.files[0])}
            />
        </Box>
    );
}

export default function UploadDialog({ label = 'Upload file', open, onClose, onUpload }) {
    const [file, setFile] = useState(null);

    const handleUpload = () => {
        if (!file) return;
        onUpload(file);
        setFile(null);
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{ sx: { borderRadius: 3 } }}
        >
            <DialogTitle sx={{ pb: 1 }}>
                {label}
                <IconButton
                    onClick={onClose}
                    sx={{ position: "absolute", right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <DndContext>
                    <DropZone onFileSelect={setFile} />
                </DndContext>

                {file && (
                    <Typography
                        variant="body2"
                        sx={{ mt: 2, textAlign: "center" }}
                    >
                        Selected: <strong>{file.name}</strong>
                    </Typography>
                )}
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 3 }}>
                <Button onClick={onClose} color="inherit">
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    onClick={handleUpload}
                    disabled={!file}
                >
                    Upload
                </Button>
            </DialogActions>
        </Dialog>
    );
}
